import { Button, ButtonGroup, HStack } from '@chakra-ui/react'
import { ConfirmIcon, ResetIcon, UndoIcon } from '@editor/assets/icons'
import { useEditorContext } from '@editor/contexts/Editor'
import { WithToolsConfig } from '@editor/interfaces/editor'
import { Tooltip } from '@infraloop/common'

import SubToolbarButton from '../SubToolbarButton'

const ToolActions = ({ toolsConfig }: WithToolsConfig) => {
  // Context
  const { selectedTool } = useEditorContext()

  // States

  // Vars
  const currentToolConfig = toolsConfig.find((tool) => tool?.key === selectedTool)

  if (
    !currentToolConfig?.auth ||
    (!currentToolConfig.hook.buttons?.undo?.isShown() && !currentToolConfig.hook.buttons?.cancel?.isShown())
  )
    return null

  return (
    <HStack bgColor="gray2.800" borderRadius="md" p={2}>
      <ButtonGroup gap={0}>
        {currentToolConfig.hook.buttons?.undo?.isShown() && (
          <SubToolbarButton
            icon={<UndoIcon size="1.2em" />}
            label={currentToolConfig.hook.buttons.undo.label || '点をひとつ戻す'}
            disabled={currentToolConfig.hook.buttons.undo.isDisabled()}
            toolType=""
            tooltipPlacement="top"
            size="lg"
            onClick={() => document.dispatchEvent(new Event('editor:tool-undo'))}
          />
        )}
        {currentToolConfig.hook.buttons?.cancel?.isShown() && (
          <SubToolbarButton
            icon={<ResetIcon size="1.2em" />}
            label={currentToolConfig.hook.buttons.cancel.label || 'キャンセル'}
            disabled={currentToolConfig.hook.buttons.cancel.isDisabled()}
            toolType=""
            tooltipPlacement="top"
            size="lg"
            onClick={() => {
              if (currentToolConfig.hook.buttons?.cancel?.onClick) {
                currentToolConfig.hook.buttons.cancel.onClick()
              } else {
                document.dispatchEvent(new Event('editor:tool-cancel'))
              }
            }}
          />
        )}
      </ButtonGroup>
      {currentToolConfig.hook.buttons?.complete?.isShown() && (
        <Tooltip label={currentToolConfig.hook.buttons.complete.tooltip} positioning={{ placement: 'top' }} showArrow>
          <Button
            aria-label={currentToolConfig.hook.buttons.complete.label || '描画中の要素を完了'}
            size="lg"
            bgColor="gray2.600"
            color="white"
            px={3}
            pr={5}
            _hover={{ bgColor: 'gray2.500' }}
            disabled={currentToolConfig.hook.buttons.complete.isDisabled()}
            onClick={() => document.dispatchEvent(new Event('editor:tool-complete'))}
          >
            <ConfirmIcon size="1.5em" />
            {currentToolConfig.hook.buttons.complete.label || '描画中の要素を完了'}
          </Button>
        </Tooltip>
      )}
    </HStack>
  )
}

export default ToolActions
